<template>
  <div>
    <header class="demos-header">
      <h1 class="demos-title">功能主界面</h1>
    </header>
    <div class="weui-grids">
      <template v-for="(wxButton, index) in wxButtonList">
        <a @click="callFn(wxButton.url)" class="weui-grid js_grid">
          <div class="weui-grid__icon">
            <img :src="wxButton.icon" alt="" />
          </div>
          <p class="weui-grid__label">
            {{ wxButton.text }}
          </p>
        </a>
      </template>
    </div>

    <div class="demos-content-padded">
      <div class="weui-footer weui-footer_fixed-bottom">
        <p class="weui-footer__links">
          <a href="javascript:void(0);" class="weui-footer__link"></a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { wxButtonList } from '@/api/sys'
import { mapActions } from 'vuex'
export default {
  name: 'HelloWorld',
  data() {
    return {
      wxButtonList: [],
    }
  },
  created() {
    this.loadWButtonList()
  },
  methods: {
    ...mapActions(['Logout']),
    loadWButtonList() {
      new Promise(resolve => {
        const data = wxButtonList().then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.wxButtonList = res
        this.wxButtonList.forEach(ele => {
          ele.icon = require('@/assets/img/' + ele.icon)
        })
        this.wxButtonList.push({ url: 'toSignfor', text: '签收' })
        // console.log(this.wxButtonList)
      })
    },
    // 退出登陆，返回至登陆页面
    logout() {
      const that = this
      that.Logout({}).then(() => {
        window.location.reload()
      }).catch(err => {
        that.$message.error({
          title: '错误',
          description: err.message
        })
      })
    },
    toRespAdd() {
      this.$router.push({ name: 'wxRespAdd' })
    },
    toCorpBusiness() {
      this.$router.push({ name: 'wxCorpBusiness' })
    },
    toOrderReceipt() {
      this.$router.push({ name: 'wxOrderReceipt' })
    },
    toRespList() {
      this.$router.push({ name: 'wxRespList' })
    },
    toProfile() {
      this.$router.push({ name: 'wxProfile' })
    },
    toSignfor() {
      this.$router.push({ name: 'wsSignfor' })
    },
    callFn(fn) {
      // this[item.fn].apply(this, item.args.split(','));
      this[fn].apply(this);
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../../assets/css/wx/weui.min.css';
@import '../../assets/css/wx/common.css';
</style>